export interface WorkflowCardData {
  id: string
  title: string
  description: string
  href: string
}

export interface ModalityData {
  [key: string]: WorkflowCardData[]
}

export const modalityWorkflows: ModalityData = {
  chat: [
    {
      id: 'chat-interface',
      title: 'Chat Interface',
      description: 'Create workflows you can chat with',
      href: '/gallery/workflows/chat-interface'
    }
  ],
  voice: [
    {
      id: 'meeting-transcription',
      title: 'Meeting Transcription',
      description: 'Auto-transcribe and summarize meetings',
      href: '/gallery/workflows/meeting-transcription'
    },
    {
      id: 'voice-assistant',
      title: 'Voice Assistant',
      description: 'Build smart voice-controlled workflows',
      href: '/gallery/workflows/voice-assistant'
    },
    {
      id: 'phone-support',
      title: 'Phone Support Bot',
      description: 'Automated customer service calls',
      href: '/gallery/workflows/phone-support'
    },
    {
      id: 'podcast-clips',
      title: 'Podcast Highlights',
      description: 'Extract key moments from audio content',
      href: '/gallery/workflows/podcast-clips'
    }
  ],
  video: [
    {
      id: 'video-subtitles',
      title: 'Auto Subtitles',
      description: 'Generate captions for any video content',
      href: '/gallery/workflows/video-subtitles'
    },
    {
      id: 'content-moderation',
      title: 'Content Moderation',
      description: 'Automatically detect inappropriate content',
      href: '/gallery/workflows/content-moderation'
    },
    {
      id: 'video-summary',
      title: 'Video Summarizer',
      description: 'Extract key insights from long videos',
      href: '/gallery/workflows/video-summary'
    },
    {
      id: 'social-clips',
      title: 'Social Media Clips',
      description: 'Auto-create clips for social platforms',
      href: '/gallery/workflows/social-clips'
    }
  ],
  image: [
    {
      id: 'product-images',
      title: 'Product Images',
      description: 'Generate marketing visuals from descriptions',
      href: '/gallery/workflows/product-images'
    },
    {
      id: 'background-removal',
      title: 'Background Removal',
      description: 'Auto-remove backgrounds from photos',
      href: '/gallery/workflows/background-removal'
    },
    {
      id: 'image-variations',
      title: 'Style Variations',
      description: 'Create multiple versions of any image',
      href: '/gallery/workflows/image-variations'
    },
    {
      id: 'thumbnail-generator',
      title: 'Thumbnail Generator',
      description: 'Auto-create thumbnails for content',
      href: '/gallery/workflows/thumbnail-generator'
    }
  ],
  form: [
    {
      id: 'lead-generation',
      title: 'Lead Generation',
      description: 'Capture and qualify leads automatically',
      href: '/gallery/workflows/lead-generation'
    },
    {
      id: 'survey-analysis',
      title: 'Survey Analysis',
      description: 'Auto-analyze form responses and feedback',
      href: '/gallery/workflows/survey-analysis'
    },
    {
      id: 'content-requests',
      title: 'Content Requests',
      description: 'Let users request custom content creation',
      href: '/gallery/workflows/content-requests'
    },
    {
      id: 'booking-system',
      title: 'Smart Booking',
      description: 'Automated scheduling and calendar integration',
      href: '/gallery/workflows/booking-system'
    }
  ],
  streaming: [
    {
      id: 'live-moderation',
      title: 'Live Moderation',
      description: 'Auto-moderate chat and content in real-time',
      href: '/gallery/workflows/live-moderation'
    },
    {
      id: 'multi-platform-stream',
      title: 'Multi-Platform',
      description: 'Stream to YouTube, Twitch, and more',
      href: '/gallery/workflows/multi-platform-stream'
    },
    {
      id: 'stream-highlights',
      title: 'Auto Highlights',
      description: 'Generate clips from live streams',
      href: '/gallery/workflows/stream-highlights'
    },
    {
      id: 'viewer-analytics',
      title: 'Viewer Analytics',
      description: 'Track engagement and optimize content',
      href: '/gallery/workflows/viewer-analytics'
    }
  ]
}